import globalEventBus from 'toxilibs/event_bus_queued.js'
import toxicodeWelcome from 'toxilibs/toxicode_welcome.js'
import getUrlParams from 'toxilibs/url_params.js'
import loadProgression from './progression_loader.js'
import challengesNavigator from './challenges_navigator.js'
import progressions from './progressions.js'

globalEventBus.on('menu displayed', globalEventBus.emitter('chef wants to quit game'))



globalEventBus.on('step completed', function (step, isLast) {
    const dataStep = step()
    if ('level' in urlParams && dataStep.next) {
        location = location.origin + '?' + dataStep.next.type + '=' + dataStep.next.location + '&directToLevel=fromNext'
        return
    }

    if (isLast) {
        globalEventBus.emit('game ended')
    }
})


globalEventBus.on('progression reset', function () {
    setTimeout(function () { //FIXME
        location.reload()
    }, 500)
})


const welcomeImages = [
    {
        url: 'images/title.png'
    },
    {
        alt: 'Compute It',
        url: 'images/illustration-w-play.png'
    }
]


globalEventBus.on('challenges added', function () {
    toxicodeWelcome(launch, {images: welcomeImages})
})





const urlParams = getUrlParams()

function launch () {
    if (challengesNavigator.getStepIndex(challengesNavigator.current) === 0 || 'directToLevel' in urlParams) {
        if (urlParams.directToLevel === 'fromNext') {
            const newUrl = getUrlParams.removeParamsFromUrl(location.href, 'directToLevel')
            history.pushState('', document.title, newUrl)
        }
        globalEventBus.emit('challenge selected', challengesNavigator.current.id)
    } else {
        globalEventBus.emit('chef wants to display menu')
    }
}



export default function () {
    loadProgression(progressions)
}

